import React from 'react';
import configureAmplify from '../../utils/configureAmplify';
import App from '../App/App';

configureAmplify();
const AuthenticatedApp = () => {
  return (
    <div>
      <App />
    </div>
  );
};

export default AuthenticatedApp;
